import { connect } from 'react-redux';
import moment from '~/Providers/Moment';

import StyledEvent from '~/Components/Pages/Calendar/StyledEvent/StyledEvent';

import { setCurrentEvent, clearEvent } from '~/Redux/Modules/Events';
import { mapCalendarsToList } from '~/Redux/Modules/CalendarAccounts';
import { DEFAULT_TIME_ZONE } from '~/Redux/Constants';
import { fontNameForEvents } from '~/Redux/Modules/UserOptions';

const mapStateToProps = ({ Events, CalendarAccounts, UserOptions, Fonts }) => {
  return {
    dragEventId: Events.dragEventId,
    isDragging: Events.isDragging,
    isFetching: Events.isFetching,
    isSyncing: Events.isSyncing,
    isUpdating: Events.isUpdating,
    isDeleting: Events.isDeleting,
    userTimeZone: moment.tz.guess() || DEFAULT_TIME_ZONE,
    calendars: mapCalendarsToList(CalendarAccounts),
    fontNameForEvents: fontNameForEvents({ Fonts, UserOptions }),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentEvent: (event, shouldOpenModal) => dispatch(setCurrentEvent(event, shouldOpenModal)),
    clearEvent: () => dispatch(clearEvent()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StyledEvent);
